import { useEffect } from 'react'
import { usePendingReviewStore } from '@/store/pendingReviewStore'
import { useDocumentStore } from '@/store/documentStore'

const POLL_INTERVAL_MS = 30_000

/**
 * Keeps the pending-review count (sidebar badge + Doc Review tab red-dot) fresh.
 * Mounted once from App. Refetches on an interval and whenever the doc list is refreshed
 * elsewhere in the app (e.g. approvals, deletes, background job completions).
 */
export function usePendingReviewPoller() {
  const fetchCount = usePendingReviewStore((s) => s.fetchCount)
  const refreshTrigger = useDocumentStore((s) => s.refreshTrigger)

  useEffect(() => {
    void fetchCount()
  }, [fetchCount, refreshTrigger])

  useEffect(() => {
    const interval = setInterval(() => {
      void fetchCount()
    }, POLL_INTERVAL_MS)
    return () => clearInterval(interval)
  }, [fetchCount])
}
